import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { jsx } from '@emotion/core';
/**
 * Replacement for jsx/createElement that adds "sicl" className to each created
 * element. The "sicl" class name allows global styles to be specified for all
 * elements created from within the component library.
 *
 * @internal
 */
export var createSICLElement = function createSICLElement(type, props) {
  for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }
  // Only apply to DOM elements, not to React components.
  if (typeof type === 'string') {
    // Typing of props is lacking, so assert the type explicitly.
    var typedProps = props;
    var _ref = typedProps || {},
      className = _ref.className;
    var newProps = _objectSpread({}, props, {
      className: "sicl".concat(className ? " ".concat(className) : '')
    });
    return jsx.apply(void 0, [type, newProps].concat(children));
  } else {
    return jsx.apply(void 0, [type, props].concat(children));
  }
};